<template>
  <v-card class="rsl-fixed-height">
    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-btn
        small
        class="mr-2"
        color="error"
        @click="promoteTables()"
        :disabled="allHqConns.length == 0"
      >{{ $t('DB_TABLES.BTNS.PROMOTE') }}</v-btn>
      <v-btn
        small
        class="mr-2"
        color="warning"
        @click="importTable()"
      >{{ $t('DB_TABLES.BTNS.IMPORT') }}</v-btn>
      <v-btn
        small
        class="mr-2"
        color="warning"
        @click="exportTables()"
      >{{ $t('DB_TABLES.BTNS.EXPORT') }}</v-btn>
      <v-btn
        small
        class="mr-2"
        color="secondary"
        @click="importData()"
      >{{ $t('DB_TABLES.BTNS.IMPORT_DATA') }}</v-btn>
      <v-btn
        small
        class="mr-2"
        color="success"
        @click="newTable()"
      >{{ $t('DB_TABLES.BTNS.NEW') }}</v-btn>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="allDbTables"
      :items-per-page="25"
      :footer-props="{'items-per-page-options':[25, 50, 100, -1]}"
      :search="search"
      class="elevation-1 mx-3 mb-3"
      item-key="ID"
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      loading-text="Loading... Please wait"
      :loading="loading"
    >
      <template slot="item.actions" slot-scope="row">
        <v-btn
          small
          class="mr-2"
          color="success"
          @click="viewTable(row.item)"
        >
          {{ $t('DB_TABLES.BTNS.VIEW') }}
        </v-btn>
        <v-btn
          small
          class="mr-2"
          color="warning"
          @click="editTable(row.item)"
        >
          {{ $t('GENERAL.BTNS.EDIT') }}
        </v-btn>
        <v-btn
          small
          class="mr-2"
          color="error"
          @click="deleteTable(row.item)"
        >
          {{ $t('GENERAL.BTNS.DELETE') }}
        </v-btn>
      </template>
    </v-data-table>

    <v-dialog
      transition="dialog-bottom-transition"
      max-width="800"
      v-model="newTableDialog"
      :retain-focus="false"
      persistent
    >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ newTableTitle }}</v-toolbar>
          <v-card-text>
            <div class="pt-5">{{ newTableText }}</div>
            <v-form v-model="isFormValid" ref="addTableForm">
              <v-row>
                <v-col cols="12" sm="12">
                  <v-text-field :label="$t('DB_TABLES.FIELDS.TABLE_NAME')" v-model="tableName" :rules="[rules.required, rules.noSpaces, rules.allowedChars]"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-data-table :headers="tableHeaders" :items="tableItems" item-key="id">
                    <template slot="top">
                      <v-toolbar
                        color="#2c3a47"
                        dark
                      >{{ $t('DB_TABLES.FIELDS.ADD_REMOVE') }}
                        <v-spacer></v-spacer>
                        <v-btn
                          small
                          class="mr-2"
                          color="success"
                          @click="addNewField()"
                        ><v-icon medium>mdi-plus</v-icon></v-btn>
                      </v-toolbar>
                    </template>
                    <template slot="item.actions" slot-scope="row">
                      <v-btn
                        v-if="row.item.fieldName != 'ID'"
                        small
                        class="mr-2 float-right"
                        color="error"
                        @click="deleteField(row.item)"
                      ><v-icon medium>mdi-trash-can-outline</v-icon></v-btn>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="cancelNewTable()"
            >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              :disabled="!isFormValid"
              @click="saveNewTable()"
            >{{ $t('GENERAL.BTNS.SAVE') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
      transition="dialog-bottom-transition"
      max-width="800"
      v-model="editTableDialog"
      :retain-focus="false"
      persistent
    >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ editTableTitle }}</v-toolbar>
          <v-card-text>
            <div class="pt-5">{{ editTableText }}</div>
            <v-form v-model="isFormValid">
              <v-row>
                <v-col cols="12" sm="12">
                  <v-text-field :label="$t('DB_TABLES.FIELDS.TABLE_NAME')" v-model="tableName" disabled></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-data-table :headers="tableHeaders" :items="tableItems" item-key="id">
                    <template slot="top">
                      <v-toolbar
                        color="#2c3a47"
                        dark
                      >{{ $t('DB_TABLES.FIELDS.ADD_REMOVE') }}
                        <v-spacer></v-spacer>
                        <v-btn
                          small
                          class="mr-2"
                          color="success"
                          @click="addNewField()"
                        ><v-icon medium>mdi-plus</v-icon></v-btn>
                      </v-toolbar>
                    </template>
                    <template slot="item.actions" slot-scope="row">
                      <v-btn
                        v-if="row.item.fieldName != 'ID'"
                        small
                        class="mr-2 float-right"
                        color="error"
                        @click="deleteField(row.item)"
                      ><v-icon medium>mdi-trash-can-outline</v-icon></v-btn>
                      <v-btn
                        v-if="row.item.fieldName != 'ID'"
                        small
                        class="mr-2 float-right"
                        color="warning"
                        @click="editField(row)"
                      ><v-icon medium>mdi-pencil-outline</v-icon></v-btn>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="cancelEditTable()"
            >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="confirmEditTable()"
            >{{ $t('GENERAL.BTNS.SAVE') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
      transition="dialog-bottom-transition"
      max-width="400"
      v-model="addFieldDialog"
      :retain-focus="false"
      persistent
    >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ addFieldTitle }}</v-toolbar>
          <v-card-text>
            <v-form v-model="isFieldValid" ref="addFieldForm">
              <v-row>
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model="fieldName"
                    :label="$t('DB_TABLES.FIELDS.FIELD_NAME')"
                    :rules="[rules.required, rules.noSpaces, rules.allowedChars]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-select
                    v-model="fieldType"
                    :label="$t('DB_TABLES.FIELDS.FIELD_TYPE')"
                    :items="fieldTypeItems"
                    :rules="[rules.requiredSelect]"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-if="fieldType == 'Decimal'"
                    v-model="decimalPlaces"
                    :label="$t('DB_TABLES.FIELDS.DECIMAL_PLACES')"
                    type="number"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-checkbox
                    v-if="fieldType != 'Boolean'"
                    v-model="allowNull"
                    :label="$t('DB_TABLES.FIELDS.ALLOW_NULL')"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="cancelAddField()"
            >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              :disabled="!isFieldValid"
              @click="confirmAddField()"
            >{{ $t('GENERAL.BTNS.SAVE') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
      transition="dialog-bottom-transition"
      max-width="400"
      v-model="editFieldDialog"
      :retain-focus="false"
      persistent
    >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ editFieldTitle }}</v-toolbar>
          <v-card-text>
            <v-form v-model="isFieldValid" ref="editFieldForm">
              <v-row>
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model="fieldName"
                    :label="$t('DB_TABLES.FIELDS.FIELD_NAME')"
                    :rules="[rules.required, rules.noSpaces, rules.allowedChars]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-select
                    v-model="fieldType"
                    :label="$t('DB_TABLES.FIELDS.FIELD_TYPE')"
                    :items="fieldTypeItems"
                    :rules="[rules.requiredSelect]"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-if="fieldType == 'Decimal'"
                    v-model="decimalPlaces"
                    :label="$t('DB_TABLES.FIELDS.DECIMAL_PLACES')"
                    type="number"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-checkbox
                    v-if="fieldType != 'Boolean'"
                    v-model="allowNull"
                    :label="$t('DB_TABLES.FIELDS.ALLOW_NULL')"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="cancelEditField()"
            >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              :disabled="!isFieldValid"
              @click="confirmEditField()"
            >{{ $t('GENERAL.BTNS.SAVE') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
      transition="dialog-bottom-transition"
      max-width="400"
      v-model="deleteTableDialog"
      :retain-focus="false"
      persistent
    >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ deleteTableTitle }}</v-toolbar>
          <v-card-text>
            <div class="pt-5">{{ deleteTableText }}</div>
            <div class="pt-5">{{ deleteTableName }}</div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="deleteTableDialog = false"
            >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="confirmDeleteTable()"
            >{{ $t('GENERAL.BTNS.CONFIRM') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
      transition="dialog-bottom-transition"
      max-width="900"
      v-model="exportTablesDialog"
      :retain-focus="false"
      persistent
    >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ exportTablesTitle }}</v-toolbar>
          <v-card-text>
            <div class="pt-5">{{ exportTablesText }}</div>
            <v-data-table
              v-model="tableExports"
              :headers="exportHeaders"
              :items="allDbTables"
              :items-per-page="10"
              class="mx-3 mb-3"
              item-key="ID"
              sort-by="TABLE_NAME"
              show-select
              loading-text="Loading... Please wait"
              :loading="loading"
            >
              <template slot="item.exportData" slot-scope="row">
                <v-switch color="success" v-model="row.item.exportData"></v-switch>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="cancelExport()"
            >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="confirmExportTables()"
            >{{ $t('GENERAL.BTNS.CONFIRM') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
        transition="dialog-bottom-transition"
        max-width="400"
        v-model="importTableDialog"
        :retain-focus="false"
        persistent
      >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ importTitle }}</v-toolbar>
          <v-card-text>
            <div class="pt-5">{{ importText }}</div>
            <v-file-input
              v-model="importedFile"
              :label="$t('DB_TABLES.IMPORT_TABLE.LABEL')"
            ></v-file-input>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="cancelImportTable()"
            >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="checkTable()"
            >{{ $t('GENERAL.BTNS.CONFIRM') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
        transition="dialog-bottom-transition"
        max-width="900"
        v-model="importDataDialog"
        :retain-focus="false"
        persistent
      >
      <template>
        <gulper @closeImportData="closeImportData" />
      </template>
    </v-dialog>

    <v-dialog
      transition="dialog-bottom-transition"
      max-width="900"
      v-model="promoteTablesDialog"
      :retain-focus="false"
      persistent
    >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ promoteTablesTitle }}</v-toolbar>
          <v-card-text>
            <div class="pt-5">{{ promoteTablesText }}</div>
            <v-data-table
              v-model="tablePromote"
              :headers="exportHeaders"
              :items="allDbTables"
              :items-per-page="10"
              class="mx-3 mb-3"
              item-key="ID"
              sort-by="TABLE_NAME"
              show-select
              loading-text="Loading... Please wait"
              :loading="loading"
            >
              <template slot="item.exportData" slot-scope="row">
                <v-switch color="success" v-model="row.item.exportData"></v-switch>
              </template>
            </v-data-table>
            <v-form v-model="isFormValid" ref="promoteForm">
              <v-select
                v-model="selectedExternalEngine"
                :label="$t('DB_TABLES.PROMOTE_TABLES.LABEL')"
                :items="allHqConns"
                item-text="ENGINE_NAME"
                item-value="URL"
                :rules="[rules.required]"
              ></v-select>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="cancelPromote()"
            >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              :disabled="!isFormValid"
              @click="confirmPromoteTables()"
            >{{ $t('GENERAL.BTNS.CONFIRM') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
      transition="dialog-bottom-transition"
      max-width="900"
      v-model="promoteResultsDialog"
      :retain-focus="false"
      persistent
    >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ promoteResultsTitle }}</v-toolbar>
          <v-card-text>
            <div class="pt-5" v-html="promoteResultsText"></div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="promoteResultsDialog = false"
            >{{ $t('GENERAL.BTNS.CLOSE') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-snackbar
      v-model="snack"
      :timeout="3000"
      :color="snackColor"
    >
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          v-bind="attrs"
          text
          @click="snack = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
  
</template>

<script>
  import $ from 'jquery';
  import { mapGetters } from 'vuex';
  import gulper from '@/components/gulper.vue'
  export default {
    name: 'databasetables',
    components: {
      gulper
    },
    computed: {
      ...mapGetters(['allDbTables', 'exportedTableData', 'allHqConns', 'promoteRes', 'errorMessage', 'gulped', 'checkTableExists'])
    },
    data: function() {
      return {
        loading: false,
        isFormValid: false,
        isFieldValid: false,
        rules: {
          required: value => !!value || 'Required',
          requiredSelect: value => {
            let res = !!value || "Required";
            return res;
          },
          noSpaces: value => (value || '').indexOf(' ') < 0 || 'No spaces are allowed',
          allowedChars: value => {
            return !/[!@#$%^&*.`~§±+£()=\-\[\]\\';,/{}|\\":<>\?]/g.test(value) || 'Only letters, numbers and underscores are allowed';
          }
        },
        deleteTableDialog: false,
        deleteTableTitle: '',
        deleteTableText: '',
        deleteTableName: '',
        deleteTableId: '',
        search: '',
        newTableDialog: false,
        newTableTitle: '',
        newTableText: '',
        editTableDialog: false,
        editTableTitle: '',
        editTableText: '',
        tableName: '',
        fieldName: '',
        fieldType: '',
        decimalPlaces: 2,
        allowNull: true,
        addFieldDialog: false,
        addFieldTitle: '',
        editFieldDialog: false,
        editFieldTitle: '',
        editFieldId: '',
        editFieldName: '',
        exportTablesDialog: false,
        exportTablesTitle: '',
        exportTablesText: '',
        promoteTablesDialog: false,
        promoteTablesTitle: '',
        promoteTablesText: '',
        promoteResultsDialog: false,
        promoteResultsTitle: '',
        promoteResultsText: '',
        importTableDialog: false,
        importTitle: '',
        importText: '',
        importedFile: null,
        importDataDialog: false,
        extractedTableName: '',
        tableExports: [],
        tablePromote: [],
        selectedExternalEngine: '',
        sortBy: '',
        sortDesc: false,
        tableHeaders: [
          { text: this.$t('DB_TABLES.FIELDS.FIELD_NAME'), align: 'start', value: 'fieldName', sortable: false },
          { text: this.$t('DB_TABLES.FIELDS.FIELD_TYPE'), value: 'fieldType', sortable: false },
          { text: this.$t('DB_TABLES.FIELDS.ALLOW_NULL'), value: 'allowNull', sortable: false },
          { text: '', value: 'actions', sortable: false }
        ],
        tableItems: [
          { fieldName: 'ID', fieldType: 'Integer', allowNull: false }
        ],
        fieldTypeItems: [ 'Integer', 'Big Integer', 'Decimal', 'Boolean', 'Varchar', 'Text', 'Longtext', 'Blob', 'Date', 'Time', 'DateTime' ],
        headers: [
          { text: this.$t('DB_TABLES.FIELDS.ID'), align: 'start', sortable: true, value: 'ID' },
          { text: this.$t('DB_TABLES.FIELDS.TABLE_NAME'), value: 'TABLE_NAME' },
          { text: this.$t('DB_TABLES.FIELDS.CREATED_ON'), value: 'CREATED_ON', sortable: false },
          { text: this.$t('DB_TABLES.FIELDS.CREATED_BY'), value: 'CREATED_BY' },
          { text: this.$t('DB_TABLES.FIELDS.UPDATED_ON'), value: 'UPDATED_ON', sortable: false },
          { text: this.$t('DB_TABLES.FIELDS.UPDATED_BY'), value: 'UPDATED_BY' },
          { text: this.$t('DB_TABLES.FIELDS.ACTIONS'), value: 'actions', sortable: false }
        ],
        exportHeaders: [
          { text: this.$t('DB_TABLES.FIELDS.TABLE_NAME'), align: 'start', value: 'TABLE_NAME' },
          { text: this.$t('DB_TABLES.FIELDS.INCLUDE_DATA'), value: 'exportData', sortable: false }
        ],
        editedItems: [],
        currentAction: '',
        previousTableItems: '',
        snack: false,
        snackColor: '',
        snackText: ''
      }
    },
    created() {
      this.unsubscribe = this.$store.subscribe((mutation) => {

        if(mutation.type === 'GULPED') {
          this.$nextTick(() => {
            if(this.gulped) {
              this.snackGulperSuccess();
            }else {
              this.snackGulperError();
            }
          });
        }

        if(mutation.type === 'ERROR_MESSAGE') {
          this.snackCreateError();
        }

        if(mutation.type === 'ADDED_TABLE') {
          this.newTableDialog = false;
          this.updateLog('Database', 'Created', 'Database table ' + this.tableName + ' created.');
          if(typeof this.$refs.addTableForm !== 'undefined') {
            this.$refs.addTableForm.resetValidation();
          }
          this.resetTable();
          this.refreshTables();
        }

        if(mutation.type === 'DELETED_TABLE' || mutation.type === 'UPDATED_TABLE' || mutation.type === 'IMPORT_DATA_SAVED') {
          this.refreshTables();
        }

        if(mutation.type === 'PROMOTE_RES') {
          let html = '';
          let tableNames = [];
          
          for(let i = 0; i < this.promoteRes.length; i++) {
            html += '<p>' + this.promoteRes[i].result + '</p>';

            if(this.promoteRes[i].promoted) {
              tableNames.push(this.promoteRes[i].tableName);
            }
          }

          if(this.promoteRes.length == 0) {
            html = '<p>' + this.$t('DB_TABLES.PROMOTE_TABLES.NONE') +'</p>';
          }

          if(tableNames.length > 0) {
            this.updateLog('Database', 'Promoted', 'Database tables ' + tableNames.toString() + ' promoted to ' + this.selectedExternalEngine + '.');
          }

          this.promoteResultsTitle = this.$t('DB_TABLES.PROMOTE_TABLES.RESULT_TITLE');
          this.promoteResultsText = html;
          this.promoteResultsDialog = true;
          this.$refs.promoteForm.reset();
        }

        if(mutation.type === 'CHECK_TABLE_EXISTS') {
          if(this.checkTableExists) {
            this.snackTableExists();
          }else {
            this.confirmImportTable();
          }
        }

      });
      this.$store.dispatch('getAllHqConnections');
      this.refreshTables();
    },
    beforeDestroy() {
      this.unsubscribe();
    },
    methods: {
      refreshTables() {
        this.loading = true;
        this.$store.dispatch('getAllTables').then( () => {
          this.loading = false;
          // Apply sort field and order
          let field = this.$store.state.databaseTablesSortField;
          let sort = this.$store.state.databaseTablesSortOrder;
          if(field == null) {
            this.sortBy = 'ID';
            this.sortDesc = true;
          }else if (sort == 'none') {
            this.sortBy = '';
            this.sortDesc = false;
          }else {
            this.sortBy = field;

            if(sort == 'descending') {
              this.sortDesc = true;
            }else {
              this.sortDesc = false;
            }
          }
          // Remove previous click events
          $('.text-start.sortable').off();
          // Add new click events for storing order
          let ref = this;
          $('.text-start.sortable').click(function() {
            let column = $(this)[0].firstChild.innerHTML;
            let order = $(this).attr('aria-sort');
            
            for(let i = 0; i < ref.headers.length; i++) {
              if(column == ref.headers[i].text) {
                ref.$store.commit('setDatabaseTablesSortField', ref.headers[i].value);
                ref.$store.commit('setDatabaseTablesSortOrder', order);
              }
            }
          });
        });
      },
      resetTable() {
        this.tableName = '';
        this.tableItems = [{ fieldName: 'ID', fieldType: 'Integer', allowNull: false }];
        this.currentAction = '';
        this.editedItems = [];
      },
      newTable() {
        this.newTableTitle = this.$t('DB_TABLES.NEW_TABLE.TITLE');
        this.newTableText = this.$t('DB_TABLES.NEW_TABLE.DESC');
        this.currentAction = 'new';
        this.newTableDialog = true;
      },
      cancelNewTable() {
        this.newTableDialog = false;
        if(typeof this.$refs.addTableForm !== 'undefined') {
          this.$refs.addTableForm.resetValidation();
        }
        this.resetTable();
      },
      viewTable(item) {
        this.$store.commit('UPDATE_TABLE_ID', item.ID);
        this.$store.commit('UPDATE_TABLE_NAME', item.TABLE_NAME);
        let payload = {
          'tableId': item.ID,
          'offset': 0,
          'orderBy': 'ID DESC',
          'pageSize': 1000
        }
        this.$store.dispatch('viewPaginatedTable', payload).then( () => {
          this.$router.push({ name: 'ViewTable' });
        });
      },
      editTable(item) {
        this.editTableTitle = this.$t('DB_TABLES.EDIT_TABLE.TITLE');
        this.editTableText = this.$t('DB_TABLES.EDIT_TABLE.DESC');
        this.tableName = item.TABLE_NAME;
        this.tableItems = JSON.parse(item.TABLE_DATA);
        this.previousTableItems = item.TABLE_DATA;
        
        for(let i = 0; i < this.tableItems.length; i++) {
          this.tableItems[i]['id'] = i;
        }

        this.currentAction = 'edit';
        this.editTableDialog = true;
      },
      confirmEditTable() {
        this.editTableDialog = false;
        if(this.editedItems.length > 0) {
          let payload = {
            'tableName': this.tableName,
            'tableData': JSON.stringify(this.tableItems),
            'editData': JSON.stringify(this.editedItems)
          };

          this.$store.dispatch('updateTable', payload).then( () => {
            this.updateLog('Database', 'Updated', 'Database table ' + this.tableName + ' updated. Previous state:' + this.previousTableItems + ' ---> Current state: ' + JSON.stringify(this.tableItems));
            if(typeof this.$refs.addTableForm !== 'undefined') {
              this.$refs.addTableForm.resetValidation();
            }
            this.resetTable();
          });
        }
      },
      cancelEditTable() {
        this.editTableDialog = false;

        if(typeof this.$refs.addTableForm !== 'undefined') {
          this.$refs.addTableForm.resetValidation();
        }
        this.resetTable();
      },
      deleteTable(item) {
        this.deleteTableTitle = this.$t('DB_TABLES.DELETE_TABLE.TITLE');
        this.deleteTableText = this.$t('DB_TABLES.DELETE_TABLE.DESC');
        this.deleteTableName = this.$t('DB_TABLES.DELETE_TABLE.TABLE') + ' ' + item.TABLE_NAME;
        this.tableName = item.TABLE_NAME;
        this.deleteTableId = item.ID;
        this.deleteTableDialog = true;
      },
      confirmDeleteTable() {
        this.deleteTableDialog = false;
        let payload = {
          'tableName': this.tableName,
          'tableId': this.deleteTableId
        };

        this.$store.dispatch('deleteTable', payload).then( () => {
          this.updateLog('Database', 'Deleted', 'Database table ' + this.tableName + ' deleted.');
          if(typeof this.$refs.addTableForm !== 'undefined') {
            this.$refs.addTableForm.resetValidation();
          }
          this.resetTable();
        });
      },
      addNewField() {
        this.allowNull = true;
        this.addFieldTitle = this.$t('DB_TABLES.ADD_EDIT_FIELD.ADD_TITLE');
        this.addFieldDialog = true;
      },
      confirmAddField() {
        let fieldExists = false;
        for(let i = 0; i < this.tableItems.length; i++) {
          if(this.tableItems[i].fieldName == this.fieldName) {
            fieldExists = true;
            break;
          }
        }
        if(fieldExists) {
          this.snackFieldExists();
        }else {
          this.addFieldDialog = false;
          this.tableItems.push({ fieldName: this.fieldName, fieldType: this.fieldType, decimalPlaces: this.decimalPlaces, allowNull: this.allowNull });
          if(this.currentAction == 'edit') {
            this.editedItems.push({ originalFieldName: '', fieldName: this.fieldName, fieldType: this.fieldType, decimalPlaces: this.decimalPlaces, allowNull: this.allowNull, action: 'create' });
          }
          if(typeof this.$refs.addFieldForm !== 'undefined') {
            this.$refs.addFieldForm.reset();
          }
        }

        // Reindex array
        for(let j = 0; j < this.tableItems.length; j++) {
          this.tableItems[j].id = j;
        }
      },
      cancelAddField() {
        this.addFieldDialog = false;
        if(typeof this.$refs.addFieldForm !== 'undefined') {
          this.$refs.addFieldForm.reset();
        }
      },
      editField(field) {
        this.editFieldTitle = this.$t("DB_TABLES.ADD_EDIT_FIELD.EDIT_TITLE");
        this.fieldName = field.item.fieldName;
        this.fieldType = field.item.fieldType;
        this.decimalPlaces = field.item.decimalPlaces;
        this.allowNull = field.item.allowNull;
        this.editFieldId = field.item.id;
        this.editFieldName = field.item.fieldName;
        this.editFieldDialog = true;
      },
      confirmEditField() {
        let fieldExists = false;
        for(let i = 0; i < this.tableItems.length; i++) {
          if(this.tableItems[i].fieldName == this.fieldName) {
            if(this.editFieldId != i) {
              fieldExists = true;
              break;
            }
          }
        }
        if(fieldExists) {
          this.snackFieldExists();
        }else {
          this.editFieldDialog = false;
          this.tableItems[this.editFieldId].fieldName = this.fieldName;
          this.tableItems[this.editFieldId].fieldType = this.fieldType;
          this.tableItems[this.editFieldId].decimalPlaces = this.decimalPlaces;

          if(this.fieldType == 'Boolean') {
            this.tableItems[this.editFieldId].allowNull = true;
          }else {
            this.tableItems[this.editFieldId].allowNull = this.allowNull;
          }
          
          if(this.currentAction == 'edit') {
            let updateField = false;
            let fieldId = 0;
            for(let i = 0; i < this.editedItems.length; i++) {
              if(this.editedItems[i].fieldName == this.editFieldName || this.editedItems[i].originalFieldName == this.editFieldName) {
                fieldId = i;
                updateField = true;
                break;
              }
            }
            if(updateField) {
              this.editedItems[fieldId].fieldName = this.fieldName;
              this.editedItems[fieldId].fieldType = this.fieldType;
              this.editedItems[fieldId].decimalPlaces = this.decimalPlaces;
              this.editedItems[fieldId].allowNull = this.allowNull;
            }else {
              this.editedItems.push({ originalFieldName: this.editFieldName, fieldName: this.fieldName, fieldType: this.fieldType, decimalPlaces: this.decimalPlaces, allowNull: this.allowNull, action: 'update' });
            }
          }
          if(typeof this.$refs.addFieldForm !== 'undefined') {
            this.$refs.addFieldForm.reset();
          }
        }
      },
      cancelEditField() {
        this.editFieldDialog = false;
        if(typeof this.$refs.addFieldForm !== 'undefined') {
          this.$refs.addFieldForm.reset();
        }
      },
      deleteField(item) {
        this.tableItems.splice(item.id, 1);

        // Reindex array
        for(let j = 0; j < this.tableItems.length; j++) {
          this.tableItems[j].id = j;
        }

        if(this.currentAction == 'edit') {
          let updateField = false;
          let spliceField = false;
          if(this.editedItems.length == 0) {
            this.editedItems.push({ originalFieldName: item.fieldName, fieldName: item.fieldName, fieldType: item.fieldType, decimalPlaces: item.decimalPlaces, allowNull: item.allowNull, action: 'delete' });
          }else {
            let fieldId = 0;
            for(let i = 0; i < this.editedItems.length; i++) {
              if(this.editedItems[i].originalFieldName == item.fieldName) {
                fieldId = i;
                updateField = true;
                break;
              }else if(this.editedItems[i].fieldName == item.fieldName) {
                fieldId = i;
                spliceField = true;
                break;
              }
            }
            if(updateField) {
              this.editedItems[fieldId].action = 'delete';
            }
            if(spliceField) {
              this.editedItems.splice(fieldId, 1);
            }
            if(!updateField && !spliceField) {
              this.editedItems.push({ originalFieldName: item.fieldName, fieldName: item.fieldName, fieldType: item.fieldType, decimalPlaces: item.decimalPlaces, allowNull: item.allowNull, action: 'delete' });
            }
          }
        }
      },
      saveNewTable() {
        let tableExists = false;
        for(let i = 0; i < this.allDbTables.length; i++) {
          if(this.allDbTables[i].TABLE_NAME == this.tableName) {
            tableExists = true;
            break;
          }
        }

        if(tableExists) {
          this.snackTableExists();
        }else {
          let payload = {
            'tableName': this.tableName,
            'tableData': JSON.stringify(this.tableItems)
          };
          this.$store.dispatch('createTable', payload);
        }
      },
      resetExport() {
        for(let i = 0; i < this.tableExports.length; i++) {
          this.tableExports[i].exportData = false;
        }
        this.tableExports = [];
      },
      cancelExport() {
        this.exportTablesDialog = false;
        this.resetExport();
      },
      exportTables() {
        this.exportTablesTitle = this.$t('DB_TABLES.EXPORT_TABLES.TITLE');
        this.exportTablesText = this.$t('DB_TABLES.EXPORT_TABLES.DESC');
        this.exportTablesDialog = true;
      },
      async confirmExportTables() {
        this.exportTablesDialog = false;
        let exportPayload = [];
        let tableNames = [];
        let eData = false;

        for(let i = 0; i < this.tableExports.length; i++) {
          if(typeof this.tableExports[i].exportData !== 'undefined') {
            eData = this.tableExports[i].exportData;
          }
          exportPayload.push({ tableName: this.tableExports[i].TABLE_NAME, exportData: eData });
          tableNames.push(this.tableExports[i].TABLE_NAME);
          eData = false;
        }
        let payload = {
          exports: JSON.stringify(exportPayload),
          count: this.tableExports.length
        };
        
        await this.$store.dispatch('exportTables', payload).then( () => {
          this.updateLog('Database', 'Exported', 'Database tables ' + tableNames.toString() + ' exported.');
          this.resetExport();

          for(let f = 0; f < this.exportedTableData.length; f++) {
            let e = document.createEvent('MouseEvents');
            let a = document.createElement('a');

            a.download = this.exportedTableData[f].fileName;
            a.href = this.exportedTableData[f].fileData;
            e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
            a.dispatchEvent(e);
          }
        });
      },
      cancelImportTable() {
        this.importTableDialog = false;
        this.importedFile = null;
      },
      importTable() {
        this.importTitle = this.$t('DB_TABLES.IMPORT_TABLE.TITLE');
        this.importText = this.$t('DB_TABLES.IMPORT_TABLE.DESC');
        this.importTableDialog = true;
      },
      checkTable() {
        let fileInfo = this.importedFile.name.split('.');
        if(fileInfo[1] != 'sql') {
          this.snackImportError();
        }else {
          this.importTableDialog = false;
          this.extractSqlContent(this.importedFile);
        }
      },
      confirmImportTable() {
        let ref = this;
        this.encodeImgtoBase64(this.importedFile, function(base64) {
          let fileName = ref.importedFile.name;

          // Strip out the base64 test at the start
          let index = base64.target.result.indexOf('base64');
          index += 7;
          let fileData = base64.target.result.slice(index);

          let payload = {
            'tableName': ref.extractedTableName,
            'name': fileName,
            'mimeType': 'application/octet-stream',
            'fileData': fileData
          }
          
          ref.$store.dispatch('importTable', payload).then( () => {
            ref.updateLog('Database', 'Imported', 'Database table ' + ref.extractedTableName + ' imported.');
            ref.importedFile = null;
            ref.snackImportSuccess();
          });
        });
      },
      closeImportData() {
        this.importDataDialog = false;
      },
      importData() {
        // this.importDataTitle = this.$t('DB_TABLES.IMPORT_DATA.TITLE');
        // this.importDataText = this.$t('DB_TABLES.IMPORT_DATA.DESC');
        this.importDataDialog = true;
      },
      // confirmImportData() {
      //   this.importDataDialog = false;
      // },
      resetPromote() {
        for(let i = 0; i < this.tablePromote.length; i++) {
          this.tablePromote[i].exportData = false;
        }
        this.tablePromote = [];
      },
      cancelPromote() {
        this.promoteTablesDialog = false;
        this.$refs.promoteForm.reset();
        this.resetPromote();
      },
      promoteTables() {
        this.promoteTablesTitle = this.$t('DB_TABLES.PROMOTE_TABLES.TITLE');
        this.promoteTablesText = this.$t('DB_TABLES.PROMOTE_TABLES.DESC');
        this.promoteTablesDialog = true;
      },
      async confirmPromoteTables() {
        this.promoteTablesDialog = false;
        let promotePayload = [];
        let tableNames = [];
        let eData = false;

        for(let i = 0; i < this.tablePromote.length; i++) {
          if(typeof this.tablePromote[i].exportData !== 'undefined') {
            eData = this.tablePromote[i].exportData;
          }
          promotePayload.push({ tableName: this.tablePromote[i].TABLE_NAME, exportData: eData });
          tableNames.push(this.tablePromote[i].TABLE_NAME);
          eData = false;
        }
        
        let payload = {
          promotes: JSON.stringify(promotePayload),
          count: this.tablePromote.length,
          tables: tableNames,
          engine: this.selectedExternalEngine
        };
        
        await this.$store.dispatch('promoteTables', payload).then( () => {
          this.resetPromote();
        });
      },
      encodeImgtoBase64(file, callback) {
        var reader = new FileReader();
        reader.onloadend = callback;
        reader.readAsDataURL(file);
      },
      extractSqlContent(file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const fileContent = e.target.result;
          const tableNameRegex = /CREATE TABLE `(\w+)`/;
          const tableNameMatch = fileContent.match(tableNameRegex);
          let tableName = tableNameMatch ? tableNameMatch[1] : null;

          // Remove "HAR_" prefix if it exists
          if (tableName && tableName.startsWith('HAR_')) {
            tableName = tableName.slice(4);
          }

          this.extractedTableName = tableName;
          this.$store.dispatch('checkTable', this.extractedTableName);
        };
        reader.readAsText(file);
      },
      snackFieldExists () {
        this.snack = true;
        this.snackColor = 'error';
        this.snackText = 'Field already exists';
      },
      snackTableExists () {
        this.snack = true;
        this.snackColor = 'error';
        this.snackText = 'Table already exists';
      },
      snackImportError () {
        this.snack = true
        this.snackColor = 'error'
        this.snackText = 'Incorrect file type. Please upload an SQL file.'
      },
      snackImportSuccess () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Table imported successfully.'
      },
      snackCreateError() {
        this.snack = true;
        this.snackTimeout = 10000;
        this.snackColor = 'error';
        this.snackText = this.errorMessage;
      },
      snackGulperError () {
        this.snack = true
        this.snackColor = 'error'
        this.snackText = 'Danger, Will Robinson!!. Something went awry, the data was not imported.'
      },
      snackGulperSuccess() {
        this.snack = true;
        this.snackTimeout = 10000;
        this.snackColor = 'success';
        this.snackText = 'The data imported successfully.';
      },
      updateLog(cat, op, msg) {
        let dt = new Date();
        let dateTime = new Intl.DateTimeFormat('en-GB', 
          {
            day: 'numeric',
            month: 'numeric', 
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            hour12: false
          }).format(dt);

        let logData = {
          'category': cat,
          'userId': this.$store.state.currentUser,
          'caseId': 0,
          'processName': null,
          'taskName': null,
          'operation': op,
          'msg': msg,
          'dateTime': dateTime,
        };
        this.$store.dispatch('updateOpLog', logData);
      }
    }
  }
</script>
